import type {GeocodePrecision} from "@mytour/shared";
import {analyticsService} from "./analytics.service.js";

/**
 * Télémétrie du callout de résolution d'adresse divergente (#864/#920,
 * re-mappée #980), factorisée pour les call-sites de la vérification
 * d'adresse (fiche client, adresse de départ x2) — jamais dans
 * `@mytour/ui`, qui n'a aucune dépendance vers `@mytour/platform`, pour ne
 * pas inverser cette direction pour un seul call-site.
 *
 * `precision` replie `null`/`undefined` (jamais mesurée) sur `"unknown"` —
 * même sémantique côté domaine (voir `geocode.model.ts`), et le contrat
 * analytics n'accepte que des `GeocodePrecision` réelles.
 *
 * `rejected` n'est plus émis depuis #980 (la confirmation bloquante qui le
 * déclenchait a disparu) — conservé pour ne pas casser l'appelant, voir
 * `useAddressVerification.ts` (`ConfirmationEvent`).
 *
 * `shown` déduplique un second déclenchement de MÊME précision dans une
 * fenêtre courte (#1124) — voir docs/context/geocodage.md § Arbitrages
 * encore ouverts pour le compromis de sous-comptage que ça implique.
 */
const SHOWN_DEDUP_WINDOW_MS = 8_000;

let lastShown: {precision: GeocodePrecision | "unknown"; at: number} | null = null;

export const geocodeConfirmationAnalytics = {
  shown(precision: GeocodePrecision | null | undefined): void {
    const normalized = precision ?? "unknown";
    const now = Date.now();
    if (
      lastShown &&
      lastShown.precision === normalized &&
      now - lastShown.at < SHOWN_DEDUP_WINDOW_MS
    ) {
      return;
    }
    lastShown = {precision: normalized, at: now};
    analyticsService.track("geocode_confirmation_shown", {precision: normalized});
  },
  confirmed(precision: GeocodePrecision | null | undefined): void {
    analyticsService.track("geocode_confirmation_confirmed", {precision: precision ?? "unknown"});
  },
  rejected(precision: GeocodePrecision | null | undefined): void {
    analyticsService.track("geocode_confirmation_rejected", {precision: precision ?? "unknown"});
  },
};
